export type StudentState = {
  role: "student";
  student: { id: string; nickname: string };
  class: { name: string; openLesson: number };
  progress: { taskId: string; lessonId: number; passed: boolean; attempts: number; bestScore: number }[];
  questions: { id: string; lessonId: number; body: string; answer: string | null; status: string; createdAt: string }[];
  drafts: { taskId: string; lessonId: number; code: string; updatedAt: string }[];
};

export type AdminState = {
  role: "admin";
  class: { id: string; name: string; code: string; openLesson: number; isClosed: boolean };
  classes: { id: string; name: string; code: string; openLesson: number; isClosed: boolean }[];
  students: {
    id: string;
    nickname: string;
    completed: number;
    bonusCompleted: number;
    attempts: number;
    lastSeenAt: string;
    presenceState: "active" | "other-tab" | "cursor-out" | "idle" | "offline";
    pointerInside: boolean;
    pointerCapable: boolean;
    presenceUpdatedAt: string | null;
  }[];
  questions: {
    id: string;
    studentId: string;
    nickname: string;
    lessonId: number;
    body: string;
    answer: string | null;
    status: string;
    createdAt: string;
  }[];
};

export type AppState = StudentState | AdminState;

const SESSION_KEY = "codequest:tab-session";

export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

export function setSessionToken(token: string) {
  sessionStorage.setItem(SESSION_KEY, token);
}

export function clearSessionToken() {
  sessionStorage.removeItem(SESSION_KEY);
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = sessionStorage.getItem(SESSION_KEY);
  const response = await fetch(`/api/${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers ?? {}),
    },
  });
  const payload = (await response.json().catch(() => ({}))) as { error?: string } & T;
  if (!response.ok) throw new ApiError(payload.error || "Er ging iets mis. Probeer het opnieuw.", response.status);
  return payload;
}
